module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/plan/plan-397-438bd39e5fb46e9d2ed03732ba51e4b2.jpg";